import React, { Component } from 'react'

// Elements
import ModalHeader from '../../elements/modalHeader'
import BottomBar from '../../elements/bottomBar'

// import styles
import './confirmok.scss'

class ConfirmOk extends Component {

  constructor (props) {
    super(props)
    this.state = {
      disabled: false
    }
  }
  componentDidMount () {
    this.setState({
      disabled: this.props.disabled === true
    })
  }

  componentWillReceiveProps (nextProps) {
    if (this.state.disabled !== nextProps.disabled) {
      this.setState({
        disabled: nextProps.disabled === true
      })
    }
  }
  render () {
    let higher = this.props.higher ? 'higher' : ''
    let disabled = this.state.disabled
    return (
      <div className='confirmok__modal__wrapper'>
        <div className={'backdrop__modal ' + higher} />
        <div className='confirmok__modal'>
          <div className='confirmok__content'>
            <ModalHeader text={this.props.headingText(this.props)} />
            <div className='pg-mb-2'>{this.props.renderText(this.props)}</div>
          </div>
          <BottomBar
            disabled={disabled}
            actionLabelText={this.props.confirmText(this.props)}
            onActionClick={this.props.confirm}
            cancelLabelText={false}
            center
          />
        </div>
      </div>
    )
  }
}

ConfirmOk.defaultProps = {
  headingText: (props) => {
    return props.t(534)
  },
  renderText: (props) => {
    return (
      <div>
        {props.t('Tekst mangler!')}
      </div>
    )
  },
  confirmText: (props) => {
    return props.t('956')
  }
}
export default ConfirmOk



// WEBPACK FOOTER //
// ./src/app/shared/components/ConfirmOk/index.js